export default {

    resetReviews: ({state, commit}) => {
        commit(
            "updateReviewsDataWithResponse", 
            window.reviews
            )

        commit("resetReviewsArray")

        commit(
            "addReviewsFromResponse",
            window.reviews.reviews
        )
    },

    

    loadReviews: async ({state, commit, getters}, pageNo) => {
        const responseReviewData = state.responseReviewData
        const ratingsToShow = state.ratingsToShow
        const locale = getters.locale
        const start = pageNo
        const liheId = state.liheId

        const isHaveResponse = responseReviewData && Object.keys(responseReviewData).length > 0
        if (isHaveResponse && (responseReviewData.pageCurrentNum === responseReviewData.pageCount)) {
            return
        }
        
        commit("setLoading", true)

        const requestData = {locale, "size": 10, start, liheId}
    
        if (ratingsToShow) {
            // Filter for reviews with the exact rating value
            // Assumes API uses exclusive upper bound (averageRatingMin <= rating < averageRatingMax)
            // For rating 3: averageRatingMin=3, averageRatingMax=4 will include all reviews with rating exactly 3
            requestData["averageRatingMin"] = ratingsToShow
            requestData["averageRatingMax"] = ratingsToShow + 1
        }
        
        try {
            const raw = await window.reviewService.getRateByLihe(requestData)
            
            const res= raw.message.rate;
        
            if (pageNo === 0) commit("resetReviewsArray")
            
            commit("updateReviewsDataWithResponse", res)
            commit("addReviewsFromResponse", res.reviews)
        } catch (error) {
            console.error("Error loading reviews:", error);
        } finally {
            commit("setLoading", false)
        }
    },
}